const PT = {
  INPUTTYPE: {
    input: {
      default: "Caixa de texto (Padrão)",
      email: "E-mail",
      scala: "Escala",
      barcode: "Código de barras",
      phone: "Telefone",
      textarea: "Área de texto",
      password: "Senha",
      flex: "Flexível",
      number: "Número",
      currency: "Moeda",
      slider: "Controle deslizante",
      ranking: "Classificação",
      ipv4: "IPV4",
      ipv6: "IPV6",
      domain: "Domínio",
      multiInput: "Lista de opções",
      checktext: "Verifique a lista de opções de tipo",
      QRReader: "Leitura de QR",
      QRGen: "Gerador QR"
    },
    file: {
      default: "upload de arquivo"
    },
    boolean: {
      standar: "Verdadeiro ou falso",
      switch: "tipo de interruptor verdadeiro ou falso"
    },
    signature: {
      sign: "Assinatura",
      photo: "Imagem de assinatura",
      dialog: "Caixa de diálogo de opção de assinatura"
    },
    choice: {
      multi: "Múltipla escolha",
      multiOther: "Múltipla escolha (outro, qual?)",
      radio: "Seleção única",
      radioOther: "Seleção única (outro, qual?)"
    },
    date: {
      datetime: "Data e hora",
      calendar: "Encontro",
      time: "Hora",
      unixtime: "Duração das atividades ou eventos"
    },
    label: {
      label: "Etiqueta",
      link: "Link",
      paragraph: "Parágrafo",
      section: "Seção",
      info: "Lista informativa",
      action: "Ações"
    },
    photo: {
      camera: "Câmera",
      gallery: "Galeria de fotos",
      "gallery/camera": "Galeria de fotos ou câmera",
      url: "Imagem por url"
    },
    viewer: {
      web: "Rede",
      document: "Documento"
    },
    geo: {
      google: "Google",
      servi: "Servinformación",
      location: "Localização (Coordenadas)"
    },
    map: {
      google: "Google",
      servi: "Servinformación"
    },
    video: {
      url: "vídeo por url"
    },
    subform: {
      standar: "Subformulário Padrão"
    },
    datasource: {
      standar: "Fonte de dados padrão",
      database: "Base de dados",
      select: "Seleção"
    }
  },
  FORMS: {
    // input: 'Cajas de texto',
    input: "Input",
    file: "Arquivo, Arquivar",
    date: "Datas",
    signature: "Assinatura",
    geo: "Geo",
    choice: "Seleção",
    boolean: "Sim ou não",
    label: "Etiqueta",
    link: "Link",
    paragraph: "Parágrafo",
    video: "Vídeo",
    photo: "Fotografia",
    map: "Mapa",
    number: "Numérico",
    network: "Internet",
    list: "Preparar",
    qr: "QR",
    informative: "Informativo",
    viewer: "Janela de informações",
    subform: "Subformulário",
    datasource: "Origem dos dados",
    save: "Salvar",
    exit: "Retornar",
    imagen_url: "Imagem por url",
    ranges: "Intervalos de entrada"
  },
  MODULE: {
    nameForm: "Nome do formulario",
    group: "Conjunto",
    version: "Versão",
    isForm: "É um subformulário?",
    addPage: "Adicionar Página",
    pagination: "Paginação",
    totalQuestions: "Total de perguntas",
    page: "Página",
    btnAddQuestion: "Adicionar pergunta",
    btnAddQuestionOteher: "Adicione outra pergunta",
    btnAddComponent: "Adicionar componente",
    btnAddComponentOther: "Adicionar outro componente",
    downloadJson: "Baixar json",
    saveForm: "Salvar formulário",
    cleanForm: "Formulário limpo",
    listForms: "Nova forma",
    openForm: "Abrir formulário",

    //TRANSLATE CARD QUESTION
    label: "Etiqueta",
    placeHolderLabel: "Nome da pergunta",
    component: "Componente",
    class: "Classe",
    description: "Descrição da Ajuda",
    subtitleDescription: "Breve descrição para orientar o usuário sobre a questão.",
    required: "Requeridos",
    btnAddDependency: "Adicionar dependência",
    setting: "Configurar",
    Pregunta: "Perguntar",
    Componente: "Componente",

    //MESSAGES ALERTS
    emptyLabel: "O rótulo não deve estar vazio e sua cadeia de caracteres deve ser maior que 2.",
    emptyOption: "O componente deve ter pelo menos uma opção.",
    requiredUrl: "Este componente requer um conteúdo ou um URL",
    requiredSubform: "Este componente requer a adição de um subformulário.",
    requiredFql: "Adicione a consulta sql ou fql.",
    requiredType: "Selecione o tipo de ação.",
    requiredOriginData: "Não há fonte de dados para este componente.",
    RequiredMainField: "Selecione o campo de pesquisa principal.",
    requiredListData: "Este componente requer a adição de uma lista de dados, digite ao configurar.",
    requiredQuestionsToActions: "Selecione as perguntas para agir",
    maxQuestionsToActions: "Você deve selecionar pelo menos duas perguntas para executar a ação",
    maxQuestionMode: "A modalidade deve conter no mínimo 3 questões.",
    requiredSelectMutipleToFlex: "O flex não está relacionado a nenhuma questão de múltipla escolha.",
    smgModeSchema: "A propriedade 'questions' das ações Deve conter pelo menos 3 elementos para o modo",
    smgTwoElements: "A propriedade 'questions' das ações deve conter pelo menos 2 elementos",
    msgContainerElements: "Não está dentro das operações disponíveis.",
    "msgErrorInheritedSubform": "Faltam campos para preencher. revise o formulário",

    //SETTING QUESTIONS
    inputText: "Digite o texto",
    hexaColor: "Cor hexadecimal",
    minValue: "Valor mínimo",
    maxValue: "Valor máximo",
    addOtherOption: "Adicionar outra opção",
    getDateYear: "Pegue os dados do ano:",
    toYear: "Até o ano:",
    selectFormatDate: "Selecione o formato de hora:",
    settingDomains: "Configurar domínios?",
    acceptAllDomains: "Aceitar todos os domínios",
    settingDomains: "Configurar domínios aceitos",
    subtitleDomain: "Domínios aceitos (@gmail.com, @hotmail.com, etc) (Define os domínios válidos aceitos.)",
    matchList: "Lista de correspondências. (Valida se o domínio atende às correspondências.)",
    typeFile: "Tipo de arquivo.",
    lengthFile: "Tamanho máximo do arquivo:",
    extensionsFiles: "Quais extensões você deseja aceitar:",
    valueMaxRanking: "Valor máximo da nota (valor inteiro).",
    titleScala: "adicionar opções",
    typePassword: "tipo de senha",
    sliderOrientation: "Orientação do controle deslizante.",
    sliderValueInitial: "Valor inicial:",
    optionMinimas: "Opções mínimas:",
    optionMaximas: "Opções máximas:",
    addOptionsTolist: "Adicione opções à lista. (Opções selecionáveis.)",
    MultiDescription: "Descrição do rótulo",
    otherWitch: "Outro, qual?",
    typeSelector: "Tipo de selecionador",
    valueDefaultSwitch: "Alternar padrão",
    SwitchDescription: "Descrição",
    selectTypePhone: "Selecione o tipo de telefone.",
    inputKey: "Digite a chave do mapa:",
    typeGeo: "Tipo de georreferenciamento",
    typeFont: "Tipo de fonte:",
    lengthFont: "Tamanho da fonte",
    textiewLabel: "Texto:",
    inputLink: "Entre no link",
    selectModeView: "Selecione o modo de exibição.",
    inputParagraph: "Digite o parágrafo:",

    containe: "Contém",
    dependencies: "Dependências",

    listInfo: {
      whereisData: "De onde você deseja extrair os dados:",
      locale: "Local",
      fromDataOrigin: "De uma fonte de dados",
      title: "Adicione as opções manualmente ou de uma fonte de dados com o botão localizado na parte inferior.",
      nameLabel: "Nome para a tag informativa",
      keyCode: "Chave de pesquisa",
      add: "Adicionar"
    },
    video: {
      label: "Digite o URL do vídeo:",
      subtitle: "Verifique se o vídeo é público na web e se contém o protocolo https."
    },
    image: {
      label: "Imagem URL:",
      subtitle: "O URL deve ser HTTPS"
    },
    map: {
      labelView: "Digite a url do mapa a ser exibido:",
      subtitleView: "Digite a url do mapa para exibir",
      subtitleKey: "Necessário para consumir serviços de georreferenciamento."
    },
    subforms: {
      labelSubform: "Selecione o subformulário",
      maxAnswer: "Número máximo de respostas:",
      minAnswer: "Número mínimo de respostas:"
    },

    originDabataseStandar: {
      typeMethod: "Selecione o método:",
      // limit: "Limite de pesquisa",
      limit: "Registros totais",
      btnOrigin: "Origem dos dados",
      keyCode: "Chave da fonte de dados",
      fieldMainSearch: "Campo de pesquisa principal:"
    },

    originDataBase: {
      typeQuery: "Tipo de consulta:",
      typeAction: "Tipo de ação:",
      query: "Consulta",
      messagge: "Mensagem"
    },

    originSelect: {
      limit: "Limite de pesquisa",
      btnOrigin: "Origem dos dados",
      typeQuery: "Tipo de consulta:",
      typeAction: "Tipo de ação:",
      query: "Consulta",
      messagge: "Mensagem"
    },

    File: {
      allExtensions: "Todas as extensões",
      images: "Imagens",
      documents: "Documentos",
      Compressed: "Arquivos compactados"
    },
    geo: {
      geo: "Geocoder",
      assisted: "Assistido",
      reverse: "Inverso"
    },
    phone: {
      movil: "Celulares",
      fixed: "Telefones fixos",
      movilFixed: "Fixo e móvel"
    },
    radio: {
      radio: "Rádio",
      comoboBox: "Caixa combo",
      unique: "Único para várias respostas"
    },
    password: {
      alphanumerico: "Alfanumérico",
      string: "Cadeia de caracteres",
      number: "Numérico"
    },
    time: {
      standar: "AM/PM",
      militar: "MILITAR"
    },
    fuentes: {
      bold: "Negrito",
      normal: "Normal",
      italic: "Itálico"
    },
    viewer: {
      embebido: "Embutido",
      popup: "Popup",
      labelInputWeb: "Insira o URL de um site:",
      labelInputDocument: "Insira o URL de um documento pdf público:",
      labelViewInformation: "Como exibir informações externas.",
      labelOrientation: "Orientação do componente."
    },
    paragraph: {
      onlyParagraph: "parágrafo apenas",
      titleParagraph: "Título e parágrafo"
    },
    orientation: {
      default: "Por padrão",
      landscape: "Paisagem",
      portrait: "Retrato"
    },
    View: {
      external: "Externo",
      popup: "Popup"
    },
    methodOrigin: {
      readWrite: "Lendo e editando",
      onlyRead: "Somente leitura"
    },
    actions: {
      on_trigger: "Ação do botão",
      on_event: "Ação por evento",
      on_depend: "Ação de dependência",
      add: "Soma",
      sub: "Subtrações sucessivas",
      multiply: 'Multiplicar',
      divider: 'Divisão',
      avg: "Média",
      mode: "Modo",
      median: "Mediana",
      min: "Mínima",
      max: "Máxima",
      default: "Sem formato",
      number: "Formato numérico",
      currency: "Formato de moeda",
      percent: "Formato de porcentagem",
      selectQuestions: "Selecione perguntas",
      actionMode: "Modo de execução",
      typeAction: "Tipo de ação",
      formatDisplay: "Formato a ser exibido",
      semicolon: 'Ponto e vírgula',
      underscore: 'sublinhado',
      pipe: 'Pipe',
      comma: 'Vírgula',
      dash: 'Traço',
      space: 'Espaço'
    }
  },
  MODALS: {
    actions: {
      listQuestions: "Lista de perguntas",
      search: "Procurar...",
      ToAccept: "Aceitar",
      cancel: "Cancelar"
    },
    originSelect: {
      title: "Selecione a pergunta para a condição",
      searchPlaceHolder: "Pesquisar por id ou descrição..."
    },
    originSelectTrigger: {
      title: "Origem dos dados",
      total: "Total de inscrições:",
      Preview: "visualizar",
      all: "Tudo"
    },
    originChoice: {
      messagge: "Quantos registros você deseja exibir nas opções?",
      messagge2: "Você já tem dados na Fonte Manual. O que você quer fazer com as novas informações?",
      add: "Adicionar",
      Replace: "Substituir",
      accept: "Aceitar"
    },
    movePage: {
      title: "Mover pergunta",
      pages: "Páginas",
      page: "Página",
      positionQuestion: "Posição da pergunta:",
      move: "Jogada",
      toInit: "No início",
      after: "Depois de",
      before: "Antes de",
      toFinal: "Ao final"
    },
    listForms: {
      titleSelect: "Selecione o formulário",
      titleClean: "Excluir formulário da lista.",
      name: "Nome",
      state: "Doença",
      date: "Encontro",
      create: "Novo",
      update: "Atualizando",
      messaggeAlert: "Você pode ter alterações não salvas.",
      confirmMessage: "Deseja excluir o formulário da lista?",
      btnAccept: "Aceitar",
      btnCancel: "Cancelar"
    },
    listInformative: {
      title: "Origem dos dados",
      selectOriginData: "Selecione uma fonte de dados",
      totalRecords: "Registros totais",
      selectField: "Selecione dois campos:",
      btnPreview: "visualizar",
      limitData: "Limite de dados",
      messagges1: "Selecione o campo que será exibido como rótulo informativo.?",
      messagges2: "Você já tem dados na lista informativa. O que você quer fazer com as novas informações?",
      btnAdd: "Adicionar",
      btnReplace: "Substituir"
    },
    flex: {
      title: "configuração flexível",
      selectQuestion: "Selecione a pergunta",
      selectOptions: "Selecione a opção",
      component: "Componente",
      btnAddQuestion: "Adicionar pergunta",
      Id: "Id",
      description: "Descrição",
      typeComponent: "Cara",
      delete: "Remover",
      maximumSize: "Comprimento máximo:",
      minimumSize: "Comprimento mínimo:"
    },
    dependencias: {
      title: "Criar dependências",
      searchPlaceHolder: "Pesquisar pergunta...",
      tabQuestion: "Perguntas",
      tabDependencies: "Dependentes",
      standar: "Padrão",
      compuesta: "Composto",
      typeRelated: "Tipo de relacionamento?",
      message: "A sequência de caracteres inserida será a condição para que as perguntas filhas sejam exibidas.",
      btnCreateDependency: "Criar dependência",
      all: "All"
    },
    modalDependencias: {
      dependence: "Dependência",
      dependencyBuilder: "Construtor de Dependências",
      standard: "Padrão",
      composite: "Composto",
      textEquals: "(Texto) Igual a",
      passEquals: "(Senha) Igual a",
      emailEquals: "(E-mail) O mesmo que",
      sliderEquals: "(Slider) Igual a",
      rankingEquals: "(Classificação) Igual a",
      numberEquals: "(Número) Igual a",
      valueEquals: "(Valor) Igual a",
      uniqueValue: "(Valor único) Igual a",
      multiValues: "Valor(es) igual a",
      codebarEquals: "(Código de Barras) Igual a",
      emptyFull: "Vazio cheio",
      remove: "Remover",
      add: "Adicionar",
      show: "Mostrar",
      delete: "Remover",
      search: "Procurar..."
    }
  }
};

export default PT;
